export const en = {
  title: 'HEADS UP',
  insufficientLicensesMessage:
    'You do not have enough licenses for everyone in this request to be given Pro access (pairs, teams, full reports, etc.). If you proceed, once your available licenses reach zero, the remaining invitees will be given Limited access. To invite everyone with Pro access, cancel this request and purchase more licenses first.',
  generalWarningMessage:
    'If you want to give Pro access to these members (pairs, teams, full reports, etc.), make sure you purchase enough Pro licenses BEFORE you send out invites. Once your available licenses reach zero, all invitees will be given Limited access! See the informational button for full details.',
  proceedWithInvitations: 'I Understand, Send Invitations',
  cancelAndPurchase: 'Cancel Invitations & Purchase Licenses',
}

export const es = en
